/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Current usage information for a user
 * @export
 * @interface DatabasesQuota
 */
export interface DatabasesQuota {
    /**
     * 
     * @type {number}
     * @memberof DatabasesQuota
     */
    numDatabasesUsed?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabasesQuota
     */
    storageCapacityUsedInMb?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabasesQuota
     */
    numDatabasesAvailable?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabasesQuota
     */
    storageCapacityInMb?: number;
    /**
     * Maximale Anzahl Datensätze pro Datenbank (null/0 = unbegrenzt)
     * @type {number}
     * @memberof DatabasesQuota
     */
    maxEntriesPerDatabase?: number;
}

/**
 * Check if a given object implements the DatabasesQuota interface.
 */
export function instanceOfDatabasesQuota(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabasesQuotaFromJSON(json: any): DatabasesQuota {
    return DatabasesQuotaFromJSONTyped(json, false);
}

export function DatabasesQuotaFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasesQuota {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'numDatabasesUsed': !exists(json, 'numDatabasesUsed') ? undefined : json['numDatabasesUsed'],
        'storageCapacityUsedInMb': !exists(json, 'storageCapacityUsedInMb') ? undefined : json['storageCapacityUsedInMb'],
        'numDatabasesAvailable': !exists(json, 'numDatabasesAvailable') ? undefined : json['numDatabasesAvailable'],
        'storageCapacityInMb': !exists(json, 'storageCapacityInMb') ? undefined : json['storageCapacityInMb'],
        'maxEntriesPerDatabase': !exists(json, 'maxEntriesPerDatabase') ? undefined : json['maxEntriesPerDatabase'],
    };
}

export function DatabasesQuotaToJSON(value?: DatabasesQuota | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'numDatabasesUsed': value.numDatabasesUsed,
        'storageCapacityUsedInMb': value.storageCapacityUsedInMb,
        'numDatabasesAvailable': value.numDatabasesAvailable,
        'storageCapacityInMb': value.storageCapacityInMb,
        'maxEntriesPerDatabase': value.maxEntriesPerDatabase,
    };
}

